import { render, staticRenderFns } from "./LayoutCol2.vue?vue&type=template&id=33835541&"
import script from "./LayoutCol2.vue?vue&type=script&lang=ts&"
export * from "./LayoutCol2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports